var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParkingBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 141.73 141.73",
    style: {
      enableBackground: "new 0 0 141.73 141.73"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Parking_-_Blue"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#10385A",
      stroke: "#10385A",
      strokeWidth: 10,
      strokeMiterlimit: 10
    },
    d: "M115.558,127.558H26.172c-6.6,0-12-5.4-12-12 V26.172c0-6.6,5.4-12,12-12h89.386c6.6,0,12,5.4,12,12v89.386C127.558,122.158,122.158,127.558,115.558,127.558z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeMiterlimit: 10
    },
    d: "M51.153,56.819"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 16,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M51.153,76.531V37.108 h19.712c10.886,0,19.712,8.825,19.712,19.712s-8.825,19.712-19.712,19.712H51.153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 16,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M51.159,92.162 c0,8.633,0,12.461,0,12.461S51.159,100.795,51.159,92.162s0-15.631,0-15.631S51.159,83.529,51.159,92.162z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingBlue);
export default __webpack_public_path__ + "static/media/Parking - Blue.69fe9bd07a682a1dd1184a8fcb84f43b.svg";
export { ForwardRef as ReactComponent };